import apiService from './api.service';
import {
  AnalysisListResponse,
  AnalysisDetail,
  AnalysisListParams,
} from '../types/analysis.types';

class AnalysisService {
  async listAnalyses(params?: AnalysisListParams): Promise<AnalysisListResponse> {
    // Build query params, converting camelCase to API format
    const queryParams: Record<string, unknown> = {
      limit: params?.limit || 50,
      offset: params?.offset || 0,
    };

    // Basic filters
    if (params?.status) queryParams.status_filter = params.status;
    if (params?.agentId) queryParams.agent_id = params.agentId;
    if (params?.contactId) queryParams.contact_id = params.contactId;
    if (params?.search) queryParams.search = params.search;

    // Full-text search
    if (params?.q) queryParams.q = params.q;

    // Compliance filters
    if (params?.complianceIdentityVerified !== undefined) {
      queryParams['compliance.identity_verified'] = params.complianceIdentityVerified;
    }
    if (params?.complianceFlagged !== undefined) {
      queryParams['compliance.flagged'] = params.complianceFlagged;
    }
    if (params?.complianceProhibitedPhrasesUsed !== undefined) {
      queryParams['compliance.prohibited_phrases_used'] = params.complianceProhibitedPhrasesUsed;
    }
    if (params?.complianceSensitiveDataShared !== undefined) {
      queryParams['compliance.sensitive_data_shared'] = params.complianceSensitiveDataShared;
    }
    if (params?.complianceMandatoryDisclosuresMissing !== undefined) {
      queryParams['compliance.mandatory_disclosures_missing'] = params.complianceMandatoryDisclosuresMissing;
    }
    if (params?.compliancePurposeNotDeclared !== undefined) {
      queryParams['compliance.purpose_not_declared'] = params.compliancePurposeNotDeclared;
    }

    // Quality filters
    if (params?.qualitySentimentFlagged !== undefined) {
      queryParams['quality.sentiment_flagged'] = params.qualitySentimentFlagged;
    }
    if (params?.qualityInterruptionsMin !== undefined) {
      queryParams['quality.interruptions_min'] = params.qualityInterruptionsMin;
    }
    if (params?.qualityGreetingMissing !== undefined) {
      queryParams['quality.greeting_missing'] = params.qualityGreetingMissing;
    }
    if (params?.qualityObjectionsUnhandled !== undefined) {
      queryParams['quality.objections_unhandled'] = params.qualityObjectionsUnhandled;
    }

    // Coaching filters
    if (params?.coachingPriority) {
      queryParams['coaching.priority'] = params.coachingPriority;
    }
    if (params?.coachingEffortScoreMin !== undefined) {
      queryParams['coaching.effort_score_min'] = params.coachingEffortScoreMin;
    }

    // Date range
    if (params?.dateFrom) queryParams.date_from = params.dateFrom;
    if (params?.dateTo) queryParams.date_to = params.dateTo;

    const response = await apiService.client.get<AnalysisListResponse>('/analysis/', {
      params: queryParams,
    });
    return response.data;
  }

  async getAnalysis(id: string): Promise<AnalysisDetail> {
    const response = await apiService.client.get<AnalysisDetail>(`/analysis/${id}`);
    return response.data;
  }
}

export default new AnalysisService();
